/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Plate } from "src/classes/plate/Plate";
import { PlateBlock } from "src/components/Block/PlateBlock";

export const Blocks = ({ plate }: { plate: Plate }) => {
  plate.observe((state) => state.blockIds); // rerender all blocks when the present blocks change
  return (
    <>
      {plate.blocks.map((block) => (
        <PlateBlock key={block.snapshot.id} plate={plate} block={block} />
      ))}
    </>
  );
};
